var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 75C33 78.3137 30.3137 81 27 81C23.6863 81 21 78.3137 21 75M33 75C33 71.6863 30.3137 69 27 69C23.6863 69 21 71.6863 21 75M33 75H57M21 75H13.5C11.0147 75 9 72.9853 9 70.5V57.0018M78 75C78 78.3137 75.3137 81 72 81C68.6863 81 66 78.3137 66 75M78 75C78 71.6863 75.3137 69 72 69C68.6863 69 66 71.6863 66 75M78 75L82.5 74.9999C84.9853 74.9999 87.0147 72.9828 86.8618 70.5022C86.0216 56.8719 81.3891 44.2675 74.0064 33.7313C72.5576 31.6637 70.2116 30.431 67.6906 30.2926H57M66 75H57M57 30.2926V26.4592C57 24.1892 55.3099 22.2688 53.0521 22.0345C46.4614 21.3506 39.7716 21 33 21C26.2284 21 19.5386 21.3506 12.9479 22.0345C10.6901 22.2688 9 24.1892 9 26.4592V57.0018M57 30.2926V57.0018M57 75V57.0018M57 57.0018H9",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.09eece4470f9eb9f83f24ba9609ef4ea.svg";
export { ForwardRef as ReactComponent };